import styled from 'styled-components'

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100%;
  min-height: 0;
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px #00000029;
  background-color: #fff;
  overflow-y: auto;

  /* max-height: 984px;
  overflow: auto; */
  .table {
    width: 100%;
    height: 100%;
    font-size: 12px;
    font-weight: 500;
    border-style: hidden;
    border-radius: 8px;
    box-shadow: 0 0 0 1px #e6e6e6;

    thead {
      background-color: #f4f5f8;
      th {
        border: 1px solid #e6e6e6;
        padding: 8px;
      }
      tr:first-child {
        th:first-child {
          border-top-left-radius: 8px;
        }
        th:last-child {
          border-top-right-radius: 8px;
        }
      }
    }

    tbody {
      th {
        border: 1px solid #e6e6e6;
        padding: 8px;
      }
      tr:last-child {
        th:first-child {
          border-bottom-left-radius: 8px;
        }
        th:last-child {
          border-bottom-right-radius: 8px;
        }
      }
    }
  }
`

export const Header = styled.div`
  padding: 16px 24px 16px 24px;
  background: #373a40;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 1;
`

export const Title = styled.div`
  font-family: SUIT;
  font-size: 22px;
  font-weight: 700;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: center;
  color: #ffffff;
`

export const Body = styled.div`
  display: flex;
  gap: 40px;
  padding: 24px;
  background: #ffffff;
`

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 50%;
`

export const FirstRow = styled.div`
  display: flex;
  gap: 80px;
`

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 0px 0px 10px;
  gap: 16px;
  font-family: SUIT;
`

export const GraphWrapper = styled.div`
  display: flex;
  width: 100%;
  padding-top: 10px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
  border-radius: 4px;
  border: 1px solid var(--gray30, #e6e6e6);
  background: var(--gray10, #fff);
`

export const GraphBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
`

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid transparent;
`

export const TableRow = styled.div`
  display: flex;
`

interface TableGrayProps {
  white?: boolean
}

export const TableCell = styled.div<TableGrayProps>`
  display: flex;

  width: 149.2px;
  height: 38px;
  padding: 8px 0px 8px 0px;
  border: 0.5px solid #e6e6e6;
  background: ${(props) => (props.white ? '' : '#f4f5f8')};

  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  align-items: center;
  justify-content: center;
`

export const TableCell2 = styled.div<TableGrayProps>`
  display: flex;

  width: 149.2px;
  height: 30.77px;
  padding: 8px 0px 8px 0px;
  border: 0.5px solid #e6e6e6;
  background: ${(props) => (props.white ? '' : '#f4f5f8')};

  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  align-items: center;
  justify-content: center;
`

export const Right = styled.div`
  display: flex;
  width: 50%;
  flex-direction: column;
  gap: 32px;
`

export const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  flex-shrink: 0;
`

interface TableGrayProps {
  white?: boolean
}

export const MonthChipWrapper = styled.div`
  display: flex;
  gap: 4px;
`

export const MonthChip = styled.div<{ selected: boolean }>`
  display: flex;
  min-width: 32px;
  height: 18px;
  padding: 0 6px;
  border-radius: 99px;
  background: #57c9a7;
  border: 1px solid #0000001a;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${({ selected }) =>
    selected ? 'rgba(87, 201, 167, 1)' : 'rgba(87, 201, 167, 0.1)'};
`

export const MonthChipText = styled.div`
  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
  color: #333333;
  user-select: none;
  white-space: nowrap;
`
